import React, { useState, useEffect } from 'react';

const GHOST_TYPES = [
    { emoji: '👻', type: 'ghost', baseSize: 24 },
    { emoji: '🦇', type: 'bat', baseSize: 22 },
    { emoji: '💀', type: 'skull', baseSize: 20 },
    { emoji: '🎃', type: 'pumpkin', baseSize: 22 },
    { emoji: '🕯️', type: 'candle', baseSize: 18 },
];

const InteractiveGhostParticles = () => {
    const [particles, setParticles] = useState([]);
    const [embers, setEmbers] = useState([]);

    useEffect(() => {
        const initialParticles = Array.from({ length: 14 }).map((_, i) => {
            const spec = GHOST_TYPES[Math.floor(Math.random() * GHOST_TYPES.length)];
            return {
                id: i,
                emoji: spec.emoji,
                type: spec.type,
                size: spec.baseSize + Math.random() * 8,
                left: Math.random() * 95,
                delay: Math.random() * 6,
                duration: 12 + Math.random() * 8,
                opacity: 0.35 + Math.random() * 0.35,
            };
        });
        setParticles(initialParticles);

        // Rising fiery embers
        const initialEmbers = Array.from({ length: 16 }).map((_, i) => ({
            id: `ember_${i}`,
            left: Math.random() * 100,
            size: 2 + Math.random() * 3,
            duration: 6 + Math.random() * 6,
            delay: Math.random() * 4,
            color: Math.random() > 0.4 ? '#f97316' : '#a855f7'
        }));
        setEmbers(initialEmbers);
    }, []);

    return (
        <div className="fixed inset-0 pointer-events-none z-[3] overflow-hidden select-none">
            {/* Rising Bonfire Embers */}
            {embers.map((em) => (
                <div
                    key={em.id}
                    className="absolute bottom-0 rounded-full animate-float-up pointer-events-none"
                    style={{
                        left: `${em.left}%`,
                        width: `${em.size}px`,
                        height: `${em.size}px`,
                        backgroundColor: em.color,
                        boxShadow: `0 0 8px ${em.color}`,
                        animationDuration: `${em.duration}s`,
                        animationDelay: `${em.delay}s`,
                        opacity: 0.75
                    }}
                />
            ))}

            {/* Floating Subtle Ambient Entities (Non-blocking, background layer) */}
            {particles.map((p) => (
                <div
                    key={p.id}
                    className="absolute bottom-[-50px] animate-ghost pointer-events-none"
                    style={{
                        left: `${p.left}%`,
                        fontSize: `${p.size}px`,
                        animationDuration: `${p.duration}s`,
                        animationDelay: `${p.delay}s`,
                        opacity: p.opacity,
                        filter: 'drop-shadow(0 0 8px rgba(249, 115, 22, 0.4)) drop-shadow(0 0 14px rgba(168, 85, 247, 0.25))',
                    }}
                >
                    {p.emoji}
                </div>
            ))}
        </div>
    );
};

export default InteractiveGhostParticles;
